module.exports = "pegasus_template/assets/column-18-basic.png";